import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'GCADA-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class GCADAConfirmDialogComponent {

    public confirmMessage: string;

    /**
     * Constructor
     *
     * @param {MatDialogRef<GCADAConfirmDialogComponent>} _dialogRef
     */
    constructor(public _dialogRef: MatDialogRef<GCADAConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public confirmDialogData: any) {
    }
}
